import React, { useCallback } from 'react'

import { TRIP_ITEMS_SORT_OPTIONS, TripItemsSortOptions } from './SavedItemsList'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import RadioButtonInput from 'components/Luxkit/RadioButton/RadioButtonInput'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { capitalise } from 'lib/string/stringUtils'

interface Props {
  onSelect: (opt: TripItemsSortOptions) => void
  selectedSortOption: TripItemsSortOptions
}

export default function SortSavedItemsModal({
  onSelect,
  selectedSortOption,
}: Props) {
  const modalElement = useModalElementContext()
  const applySelectedSortOption = useCallback(
    (option: TripItemsSortOptions) => {
      onSelect(option)
      modalElement?.resolve()
    },
    [modalElement, onSelect],
  )
  return (
    <ModalBase>
      <ModalHeader title="Sort by" />
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={12}>
            {TRIP_ITEMS_SORT_OPTIONS.map((opt) => (
              <div key={opt}>
                <RadioButtonInput
                  onClick={() => applySelectedSortOption(opt)}
                  checked={opt === selectedSortOption}
                >
                  {capitalise(opt)}
                </RadioButtonInput>
              </div>
            ))}
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}
